<i18n
  src="@/locales/views/packing_house/production/packing_by_pallet/list_processes.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">
      {{ module_name }}
    </h1>
  </div>

  <div
    v-if="load_general_data"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="packing_house_process in packing_house_processes"
        :key="packing_house_process.id"
      >
        <div
          class="block hover:bg-gray-50 cursor-pointer"
          @click.prevent="goToShowProcess(packing_house_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ packing_house_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>
                  {{ $t("labels.manage_link") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/packing_by_pallet/list_processes.js";

export default {
  name: "PHProductionPackingByPalletListProcesses",
  props: { packing_house_id: { required: true } },
  data() {
    return {
      load_general_data: false,
      packing_house_processes: [],
    };
  },
  methods: {
    fetchPackingHouseProcesses: async function () {
      let response = await Requester.fetchPackingHouseProcesses(
        this.packing_house_id
      );
      this.packing_house_processes = response.data;
      this.load_general_data = true;
    },
    goToShowProcess: function (packing_house_process) {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: packing_house_process.id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => this.fetchPackingHouseProcesses())
    );
  },
};
</script>
